import { render, staticRenderFns } from "./ParticipantsDemo.vue?vue&type=template&id=8c9c3742"
import script from "./ParticipantsDemo.vue?vue&type=script&lang=js"
export * from "./ParticipantsDemo.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsDemo.vue?vue&type=style&index=0&id=8c9c3742&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports